import { ChatFragment } from 'components/chat/query/__generated__/chats-list';

export function getChatById(chats: ChatFragment[], chatId: string) {
  return chats.find((chat) => chat.id === chatId);
}
